export const AUTONOMY_DOMAINS = [
  { key: 'WELLBEING', label: 'Bienestar', color: '#0f6938' },
  { key: 'WATER_INFRASTRUCTURE', label: 'Agua e infraestructuras', color: '#1C7293' },
  { key: 'ECONOMIC_OPPORTUNITY', label: 'Oportunidad económica', color: '#E58D1F' },
  { key: 'COLLECTIVE_ACTION', label: 'Acción Colectiva', color: '#6D2E46' },
  { key: 'SYSTEM_INTEGRATION', label: 'Integración y acceso de sistemas', color: '#21295C' },
  { key: 'EDUCATION', label: 'Educación', color: '#2C5F2D' }
]

const DEFAULT_DOMAIN_COLOR = '#9E9E9E'

export const colorForDomainCode = (code) => {
  const domain = AUTONOMY_DOMAINS.find((d) => d.key === code)
  return domain ? domain.color : DEFAULT_DOMAIN_COLOR
}

export const STRUCTURAL_FACILITATOR_DOMAINS = ['SYSTEM_INTEGRATION', 'EDUCATION']

export const AUTONOMY_LEVELS = [
  { value: 0, label: 'L0 · Dependencia' },
  { value: 1, label: 'L1 · Conciencia' },
  { value: 2, label: 'L2 · Participación' },
  { value: 3, label: 'L3 · Gestión' },
  { value: 4, label: 'L4 · Liderazgo' },
  { value: 5, label: 'L5 · Autonomía' }
]

export const deriveLevel = (score) => {
  if (score === null || score === undefined) return null
  return Math.min(5, Math.max(0, Math.floor(score)))
}

export const levelLabel = (value) => {
  const level = AUTONOMY_LEVELS.find((l) => l.value === value)
  return level ? level.label : ''
}

export const CHECKLIST_TYPE_LABELS = {
  MONTHLY: 'Mensual',
  BIANNUAL: 'Semestral',
  ANNUAL: 'Anual'
}

export const INTERVENTION_KINDS = [
  { value: 'INTERVENTION', label: 'Intervención' },
  { value: 'ENABLER', label: 'Acción facilitadora' }
]

export const CHECKLIST_ANSWERS = [
  { value: 'YES', label: 'Sí' },
  { value: 'NO', label: 'No' },
  { value: 'NA', label: 'N/A' }
]

export const COMMENT_TAGS = [
  { value: 'ACCESS_RESTRICTED', label: 'Acceso restringido', color: 'error' },
  { value: 'ACTION_REQUIRED', label: 'Se requiere acción', color: 'warning' },
  { value: 'IMPROVING', label: 'Mejorando', color: 'success' }
]

export const TEAM_ACTIVITY_INDICATORS = [
  {
    key: 'nutrition',
    label: 'Evaluaciones nutricionales',
    totalKey: 'totalEvaluations',
    breakdown: [
      { key: 'normalWeight', label: 'Peso normal' },
      { key: 'mildMalnutrition', label: 'Desnutrición leve' },
      { key: 'moderateMalnutrition', label: 'Desnutrición moderada' },
      { key: 'chronicMalnutrition', label: 'Desnutrición crónica' },
      { key: 'recovered', label: 'Recuperados' }
    ]
  },
  {
    key: 'socialWork',
    label: 'Evaluaciones de Trabajo Social',
    totalKey: 'totalEvaluations',
    breakdown: [
      { key: 'noRightsViolations', label: 'Sin vulneración de derechos' },
      { key: 'moderateRightsViolation', label: 'Vulneración moderada de derechos' },
      { key: 'severeRightsViolation', label: 'Vulneración severa de derechos' },
      { key: 'unknown', label: 'Desconocido' }
    ]
  },
  {
    key: 'psychopedagogy',
    label: 'Evaluaciones de Psicopedagogía',
    totalKey: 'totalEvaluations',
    breakdown: [
      { key: 'normal', label: 'Normal' },
      { key: 'risk', label: 'Riesgo' },
      { key: 'severe', label: 'Severo' },
      { key: 'unknown', label: 'Desconocido' }
    ]
  },
  {
    key: 'milkKilos',
    label: 'Kilos de leche entregados',
    totalKey: 'totalKilos',
    breakdown: []
  },
  {
    key: 'workshops',
    label: 'Talleres realizados',
    totalKey: 'total',
    breakdown: []
  },
  {
    key: 'hospitalAccompaniment',
    label: 'Acompañamiento hospitalario',
    totalKey: 'total',
    breakdown: []
  },
  {
    key: 'familyCompanion',
    label: 'Acompañante familiar',
    totalKey: 'total',
    breakdown: []
  },
  {
    key: 'foodModules',
    label: 'Módulos alimentarios',
    totalKey: 'total',
    breakdown: []
  }
]
